export const queryBuilder = (eventIds) => `$filter=id in(${[...new Set(eventIds)].map(id => `'${id}'`).join(",")})`;
//# sourceMappingURL=queryBuilder.js.map